import React, { useRef, useState, useEffect } from 'react'
import { Button, Card, Checkbox, Col, Descriptions, Divider, Drawer, Flex, Image, Input, message, Modal, Row, Select, Table, Tag, Tooltip, Typography } from 'antd'
import moment from 'moment'
import { CloudDownloadOutlined, DeleteFilled, ExportOutlined, InfoCircleOutlined, InfoCircleTwoTone, InfoOutlined, LockFilled, NumberOutlined, PlusCircleTwoTone, PrinterFilled, PrinterOutlined, SnippetsOutlined, UnlockFilled } from '@ant-design/icons';
import AuthService from '../auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { styled } from '@mui/system';
import { showMessage } from '../Utils/message';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import ProductScanSelect from '../../pages/Scan/ProductScanSelect';
import ScanSelect from '../../pages/Scan/ScanSelect';
import { env, wms_uploads_cdn } from '../config';
import DetailsGrid from '../common/DetailsGrid';
import ProductInfoModal from '../Modals/ProductInfoModal';
import LockPalletPackingButton from '../common/LockPalletPackingButton';
import { SpaTwoTone } from '@mui/icons-material';
import InputBox from '../common/InputBox';
import { getBase64Image, getProductImageUrl } from '../../utils';
import html2pdf from 'html2pdf.js';

const Auth = new AuthService();
const TableSheet = styled('div')`
   
    .ant-input-outlined[disabled] {
      background-color: none;
      color: black;
      font-weight: 500;
    }
`;

const PalletDrawer = ({ drawerOpen, drawerClose, selectedRouteDetails, deliveryDate, selectedRoute, palletData, setPalletData, getRouteStatus, getRoutePackingDetails, selectedPalletWeight, routeStatusData, setRouteStatusData }) => {
    console.log('selectedRoute', palletData);
    const { locations, products } = useSelector((state) => state?.AppState?.userCreds);
    const { Text } = Typography;
    const { Option } = Select;
    const layoutDispatch = useLoadingDispatch()
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemPickingTransactions, setItemPickingTransactions] = useState([])
    const [itemPackingTransactions, setItemPackingTransactions] = useState([])
    const [packRouteStock, setPackRouteStock] = useState({
        product: "",
        product_id: '',
        location: "",
        location_id: null,
        quantity: "",
        productText: '',
        locationText: '',
        productStatus: null,
        locationStatus: null,
        batch_id: null,
        batch_expiry: null,
        batch_quantity: '',
        batch_code: '',
        supplier_batch_code: '',
        remaining_quantity_check: false,
        fullPallet: false,
        fullPalletShow: false,
        remainQtyShow: false,
    });
    const [currentProduct, setCurrentProduct] = useState(null)

    const [modalVisibleProduct, setModalVisibleProduct] = useState(false);
    const [quantityModalVisible, setQuantityModalVisible] = useState(false);
    const [quantityRecord, setQuantityRecord] = useState(null);
    const [selectedProductDetails, setSelectedProductDetails] = useState({
        totalStock: 0,
        code: '',
        name: '',
        productDetails: [],
        selectedRecord: null
    });

    const imageUrl = getProductImageUrl(currentProduct);

    const productRef = useRef(null);
    useEffect(() => {
        if (modalVisible) {
            setTimeout(() => {
                productRef.current?.focus();
            }, 100);
        }
    }, [modalVisible]);

    const handleSelect = async (record) => {
        console.log('record', record);
        if (record?.remaining_picked_quantity < 1 && record?.packed_quantity < 1) return showMessage('error', 'No remaining picked quantity available for packing');

        const selectedProduct = products?.find((pro) => pro?.code == record?.item_id);
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch(`/route/route-picking-txn?route_status_id=${selectedRoute?.id}&product_netsuite_id=${selectedProduct?.netsuite_id}`);
            if (res?.ack) {
                const data = res?.route_data || [];

                // const grouped = Object.values(
                //     data?.reduce((acc, curr) => {
                //         const key = curr.purchase_order_details_batch_id;
                //         if (!acc[key]) {
                //             acc[key] = { ...curr, quantity: 0 };
                //         }
                //         acc[key].quantity += curr.quantity;
                //         return acc;
                //     }, {})
                // ).map((item) => ({
                //     ...item,
                //     final_quantity: item.quantity - item.added_quantity,
                // }));
                const grouped = data?.map((item) => ({
                    ...item,
                    final_quantity: (item.quantity || 0) - (item.added_quantity || 0),
                }));

                const updatedItems = grouped;
                console.log('updatedItems', updatedItems);


                try {
                    const PackedRes = await Auth.fetch(`/route/route-packing-batches?item_pallet_id=${record?.item_pallet_id}`);
                    if (PackedRes?.ack) {
                        const totalQuantityAdded = PackedRes?.route_batches.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
                        const currentItemID = PackedRes?.route_batches[0]?.item_pallet_id;
                        const updatedRemainingQty = Number(record?.quantity) - Number(totalQuantityAdded);
                        const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
                        const updatedData = palletData.map(item => {
                            if (item.item_pallet_id === currentItemID) {
                                return { ...item, remaining_quantity: updatedRemainingQty, packed_quantity: totalQuantityAdded };
                            }
                            return item;
                        });
                        const selectedProduct = products?.find((pro) => pro?.netsuite_id == record?.item_internal_id);
                        const selectedProductCasesInPallets = selectedProduct?.cases_in_pallets
                        const capacityStaus = updatedRemainingQty >= selectedProductCasesInPallets ? true : false;
                        if (capacityStaus) {
                            setPackRouteStock({ ...packRouteStock, fullPalletShow: true, remainQtyShow: false })
                        } else {
                            setPackRouteStock({ ...packRouteStock, fullPalletShow: false, remainQtyShow: true })
                        }
                        setPalletData(updatedData);
                        setSelectedItem(updatedRecord)
                        const pickingItems = updatedItems || [];
                        setItemPickingTransactions(pickingItems);
                        setItemPackingTransactions(PackedRes?.route_batches || []);
                        setCurrentProduct(null);
                        setModalVisible(true);

                        const validItems = pickingItems?.filter(item => (item.final_quantity || 0) > 0) || [];
                        if (validItems.length === 1) {
                            const singleBatch = validItems[0];
                            setPackRouteStock(prev => ({
                                ...prev,
                                batch_id: singleBatch.id,
                                batch_quantity: singleBatch.final_quantity || 0,
                                id: singleBatch.id || null,
                                purchase_order_details_batch_id: singleBatch.purchase_order_details_batch_id || 0,
                                batch_code: singleBatch.batch_code || 0,
                                supplier_batch_code: singleBatch.supplier_batch_code || 0,
                                batch_expiry: singleBatch.expiry_date || 0,
                            }));
                        }
                    } else {
                        setSelectedItem('')
                        setItemPackingTransactions([]);
                        setItemPickingTransactions([]);
                        setCurrentProduct(null);
                        showMessage('error', PackedRes?.message || 'Something went wrong while fetching packing transactions try again!');
                    }
                } catch (err) {
                    showMessage('error', 'Something went wrong while fetching packing transactions');
                }



            } else {
                showMessage('error', res?.message);
                setItemPickingTransactions([])
            }
        } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong');
        }
        finally {
            hideLoading(layoutDispatch)
        }
    };

    const getTotalPackedWeight = () => {
        if (!Array.isArray(palletData)) return 0;
        return palletData.reduce((total, item) => {
            const weight = item.item_weight || 0;
            const qty = item.packed_quantity || 0;
            return total + weight * qty;
        }, 0);
    };


    const infoItemsTitle = [
        { label: 'Date', value: deliveryDate ? dayjs(deliveryDate).format('DD-MM-YYYY') : 'N/A' },
        { label: 'Route', value: selectedRoute?.title || 'N/A' },
        { label: 'Vehicle', value: selectedRoute?.registration_number || 'N/A' },
        { label: 'Driver', value: selectedRoute?.driver_name || 'N/A' },
    ];
    const infoItems = [
        { label: 'Pallet No.', value: selectedRouteDetails?.palet_id || 'N/A' },
        { label: 'Pallet Weight', value: `${selectedPalletWeight?.toFixed(2)} Kg` },
        { label: 'Packed Weight', value: `${getTotalPackedWeight().toFixed(2)} Kg` },
    ];


    const dataCol = [
        {
            title: 'Order No.',
            render(record) {
                const document = record?.invoice_no ? record?.invoice_no : record?.sale_order_no
                return (
                    <span>{document || '-'}</span>
                );
            }
        },
        {
            title: 'Shop',
            render(record) {
                return (
                    <span>{record ? `${record?.customer_name} - ${record?.customer_project_id}` : '-'}</span>
                );
            }
        },

        // {
        //     title: 'Shop Name',
        //     render(record) {
        //         return (
        //             <span>{record ? `${record?.customer_project_id}` : '-'}</span>
        //         );
        //     }
        // },
        {
            title: 'Item',
            render(record) {
                return (
                    <Flex gap={5} align="center">
                        <Tooltip title={'Product Info'}>
                            <InfoCircleTwoTone
                                style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                                onClick={() => handleInfoClick(record)}
                            />
                        </Tooltip>
                        <span>{record ? `${record?.item_id} - ${record?.item_name}` : '-'}</span>
                    </Flex>
                );
            }
        },
        {
            title: 'Picking Info',
            align: 'center',
            width: 100,
            render(record) {
                return (
                    <Tooltip title={'View Picking Details'}>
                        <InfoCircleTwoTone
                            twoToneColor="#52c41a"
                            style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                            onClick={() => {
                                setQuantityRecord(record);
                                setQuantityModalVisible(true);
                            }}
                        />
                    </Tooltip>
                );
            }
        },


        {
            title: 'Qty',
            align: 'center',
            render(record) {
                return (
                    <span>{record?.quantity ? `${record?.quantity?.toLocaleString()}` : 0}</span>
                );
            },
            onCell: () => ({
                style: {
                    backgroundColor: "#f2e3b5ff", // light blue for picked
                    fontWeight: "bold",
                },
            }),

        },

        {
            title: 'Packed Qty',
            align: 'center',
            render(record) {
                const packed = Number(record?.packed_quantity) || 0;
                const total = Number(record?.quantity) || 0;
                const isFullyPacked = packed === total && total > 0;
                const isPartiallyPacked = packed > 0 && !isFullyPacked;
                const color = isFullyPacked ? "#389e0d" : isPartiallyPacked ? "#d46b08" : "#cf1322";

                return (
                    <span style={{ fontSize: 16, fontWeight: 'bold', color }}>
                        {packed.toLocaleString()}
                    </span>
                );
            },
            onCell: (record) => {
                const packed = Number(record?.packed_quantity) || 0;
                const total = Number(record?.quantity) || 0;
                const isFullyPacked = packed === total && total > 0;
                const isPartiallyPacked = packed > 0 && !isFullyPacked;

                return {
                    style: {
                        backgroundColor: isFullyPacked ? "#b7eb8f" : isPartiallyPacked ? "#ffe58f" : "#ffa39e",
                        fontWeight: "bold",
                        transition: 'all 0.3s'
                    },
                };
            },
        },
        {
            title: 'Remaining Packed Qty',

            render(record) {
                return <span style={{ fontSize: 16, fontWeight: 'bold', color: record?.remaining_quantity > 0 && 'red' }}>{record?.remaining_quantity}</span>
            },
            onCell: () => ({
                style: {
                    backgroundColor: "#d6f4ecff", // light blue for picked
                    fontWeight: "bold",
                },
            }),
            align: 'center'
        },
        {
            title: "Action",
            align: "center",
            render: (record) => (
                <>
                    {
                        record?.picked_quantity > 0 ? (
                            <Tooltip title="Select Item">
                                <ExportOutlined
                                    className="animated-select-icon"
                                    onClick={() => handleSelect(record)}
                                    disabled={record?.quantity < 1}
                                />
                            </Tooltip>
                        ) : (
                            <ExportOutlined
                                className="animated-select-icon-disabled"
                            />
                        )
                    }
                </>

            ),
        }
    ];

    const handleDownloadPdf = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const boxWidthLabel = 20;
        const boxWidthValue = 75;
        const boxHeight = 8;
        const startX = 4;

        // This is the vertical space taken by the header section (estimate)
        const headerHeight = 45;

        const drawFullHeader = (doc) => {
            const totalQuantity = palletData?.reduce((sum, item) => sum + (item.packed_quantity || 0), 0) || 0;

            const rectWidth = 40;
            const qtyX = 4;
            const qtyY = 10;
            doc.setFontSize(12);
            doc.setFont(undefined, 300);
            doc.rect(qtyX, qtyY, rectWidth, boxHeight);
            doc.text(`Quantity: ${totalQuantity}`, qtyX + 2, qtyY + 5);

            const weightX = qtyX + rectWidth + 6; // small gap between boxes
            const weightY = qtyY;
            doc.setFontSize(12);
            doc.setFont(undefined, 300);
            doc.rect(weightX, weightY, rectWidth + 9, boxHeight);
            doc.text(`Pallet Weight: ${selectedPalletWeight?.toFixed(2) || 0}KG`, weightX + 2, weightY + 5);

            const palletNo = selectedRouteDetails?.palet_id || 'N/A';
            doc.setFontSize(18);
            doc.setFont(undefined, 'bold');
            doc.text(`Pallet# ${palletNo}`, 180, 15);



            let y = 20;

            const combinedInfo = [
                ['Date', deliveryDate ? dayjs(deliveryDate).format('DD-MM-YYYY') : 'N/A'],
                ['Route', selectedRoute?.title || 'N/A'],
                ['Vehicle', selectedRoute?.registration_number || 'N/A'],
                ['Driver', selectedRoute?.driver_name || 'N/A'],
            ];

            doc.setFontSize(11);
            doc.setFont(undefined, 'bold');

            combinedInfo.forEach(([label, value], index) => {
                const currentY = y + index * boxHeight;

                doc.setDrawColor(0);
                doc.rect(startX, currentY, boxWidthLabel, boxHeight);
                doc.text(label, startX + 2, currentY + boxHeight / 1.5);

                doc.rect(startX + boxWidthLabel, currentY, boxWidthValue, boxHeight);
                doc.setFont(undefined, 'normal');
                doc.text(String(value), startX + boxWidthLabel + 2, currentY + boxHeight / 1.5);

                doc.setFont(undefined, 'bold');
            });

            // Shop names
            const listStartX = startX + boxWidthLabel + boxWidthValue + 3;
            const listStartY = y + 3;
            const shopNames = [...new Set(palletData.map(item => `${item.customer_name} - ${item.customer_project_id}` || '-'))];

            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            shopNames.forEach((name, index) => {
                const currentY = listStartY + index * 6;
                const trimmedName = name.length > 70 ? name.slice(0, 67) + '...' : name;
                doc.text(`${index + 1}. ${trimmedName}`, listStartX, currentY);
            });
        };

        const headers = [['Shop', 'Item', 'Packed Quantity']];
        const dataRows = palletData.map(item => ([
            `${item.customer_name} - ${item.customer_project_id}` || '-',
            `${item.item_id} - ${item.item_name}` || '-',
            item.packed_quantity || 0,
        ]));

        // Always draw header before table
        drawFullHeader(doc);

        doc.autoTable({
            startY: headerHeight + 10,
            head: headers,
            body: dataRows,
            styles: { fontSize: 9 },
            headStyles: { fillColor: [22, 160, 133] },
            columnStyles: {
                2: { halign: 'center' } // Align 'Quantity' column to the right (3rd column = index 2)
            },
            margin: { top: headerHeight + 10, left: 4, right: 4 },
            didDrawPage: function (data) {
                // Redraw the header on every page before table
                drawFullHeader(doc);

                // Page number at bottom right
                const pageNumber = doc.internal.getNumberOfPages();
                doc.setFontSize(10);
                doc.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 10);
            }
        });

        const palletNo = selectedRouteDetails?.palet_id || 'N/A';
        doc.save(`${selectedRoute?.code}_${selectedRoute?.registration_number}_${dayjs(deliveryDate).format('DD-MM-YYYY')}_P${palletNo}_.pdf`);
    };

    const uniqueCustomers = [
        ...new Map(
            palletData.map(item => [
                `${item.customer_name}-${item.customer_project_id}`,
                {
                    name: item.customer_name || '-',
                    project: item.customer_project_id || '-',
                    rank: item.rank
                }
            ])
        ).values()
    ].sort((a, b) => a.rank - b.rank);

    const customerListHtml = uniqueCustomers
        .map(customer => `
        <div class="label-row">
            ${customer.rank}. ${customer.name} - ${customer.project}
        </div>
    `)
        .join('');


    const handleDownloadPalletLabel = async () => {
        if (!palletData?.length) return;

        var url = env === "prod"
            ? `https://magnawms.com/pallet-info/${palletData[0]?.pallet_security_code}`
            : `http://uat.magnawms.com/pallet-info/${palletData[0]?.pallet_security_code}`;

        var qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(url)}`;

        try {
            const logoBase64 = await getBase64Image("/assets/logo.png");
            const qrBase64 = await getBase64Image(qrCodeUrl);

            var palletInfoHtml = `
            <div class="label-container">
                <div class="label-header">
                    <img src="${logoBase64}" class="logo" alt="magna" />
                    <div class="header-title">PALLET ${selectedRouteDetails?.palet_id || 'N/A'}</div>
                </div>    
                <div class="label-header vehicle-info">
                    <div class="header-title">${selectedRoute?.registration_number || 'N/A'}</div>
                </div>    
                <div class="label-info-container">
                    <div class="label-info-left">
                        <div class="left-label-row"><span class="left-label-title">Date: </span><span class="left-label-value">${deliveryDate ? dayjs(deliveryDate).format('DD-MM-YYYY') : 'N/A'}</span></div>
                        <div class="left-label-row"><span class="left-label-title">Route: </span><span class="left-label-value">${selectedRoute?.title || 'N/A'}</span></div>
                        <div class="left-label-row"><span class="left-label-title">Driver: </span><span class="left-label-value">${selectedRoute?.driver_name || 'N/A'}</span></div>
                    </div>
                    <div class="label-info-right">
                        <img src="${qrBase64}" alt="QR Code" />
                    </div>
                </div>
                <div class="label-box">
                    <div class="label-title">Shops</div>
                    ${customerListHtml}
                </div>

                <div class="quantity-weight-box">
                    <div class="qw-column">
                        <div class="qw-label">Total Items </div>
                        <div class="qw-value">${palletData?.length || 0}</div>
                    </div>
                    <div class="qw-divider"></div>
                    <div class="qw-column">
                        <div class="qw-label">Weight </div>
                        <div class="qw-value">${selectedPalletWeight?.toFixed(2) || 0} KGs</div>
                    </div>
                </div>

            </div>
            `;

            const style = `
        <style>

            @page {
                size: 101mm 152mm;
                margin: 0;
            }

            body {
                margin: 0;
                padding: 0;
                font-family: Arial, sans-serif;
                font-size: 14px;
            }

            .page-break {
                page-break-after: always;
                padding: 8mm 5mm;
                box-sizing: border-box;
            }

            .label-container {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }

            .label-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border: 2px solid black;
                padding: 0px 6px;
            }

            .vehicle-info {
                justify-content: center;
            }

            .logo {
                height: 55px;
            }

            .header-title {
                font-size: 44px;
                font-weight: bold;
                text-align: center;
            }

            .label-info-container {
                display: flex;
                justify-content: space-between;
                gap: 8px;
            }

            .label-info-left {
                flex: 1.5;
                border: 1px solid black;
                padding: 6px;
                display: flex;
                flex-direction: column;
                gap: 4px;
                font-size: 16px;
            }

            .left-label-row {
                display: flex;
                justify-content: space-between;
                border-bottom: 0.5px solid #333;
                padding-bottom: 2px;
            }

            .left-label-row:last-child {
                border-bottom: none;
            }

            .left-label-title {
                font-weight: bold;
                min-width: 80px;
            }

            .left-label-value {
                flex: 1;
                text-align: right;  
                word-break: break-word;
            }

            .label-info-right {
                width: 35%;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px dashed #333;
                padding: 4px;
            }

            .label-info-right img {
                width: 95px;
                height: 95px;
            }

            .label-box {
                border: 1px solid black;
                padding: 6px;
                display: flex;
                flex-direction: column;
                gap: 3px;
                font-size: 16px;
            }

            .label-title {
                font-weight: bold;
                margin-bottom: 4px;
            }

            .label-row {
                line-height: 1.2;
            }

            .quantity-weight-box {
                display: flex;
                border: 1.5px solid black;
                font-size: 18px;
            }

            .qw-column {
                padding: 6px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 5px;
            }
            
            .qw-column:first-child {
                width: 40%;
            }

            .qw-column:last-child {
                width: 60%;
            }

            .qw-divider {
                width: 1px;
                background: black;
            }

            .qw-label {
                font-weight: bold;
                white-space: nowrap;
            }

            .qw-value {
                text-align: right;
                white-space: nowrap;
            }
        </style>
        `;

            var container = document.createElement("div");
            container.innerHTML = style + palletInfoHtml;
            document.body.appendChild(container);


            var options = {
                margin: [5, 3, 0, 3],
                filename: `${selectedRoute?.code}_${selectedRoute?.registration_number}_${dayjs(deliveryDate).format('DD-MM-YYYY')}_PALLET_LABEL_${selectedRouteDetails?.palet_id}_.pdf`,
                image: { type: "jpeg", quality: 1 },
                html2canvas: { scale: 3 },
                jsPDF: { unit: "mm", format: [101, 152], orientation: "portrait" }
            };

            await html2pdf().set(options).from(container).save();
            document.body.removeChild(container);

        } catch (err) {
            console.error("Failed to generate PDF:", err);
        }
    }
    console.log('palletData', palletData);


    const handleModalCancelProduct = () => {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: '', name: '', productDetails: [], selectedRecord: null });
        setModalVisibleProduct(false);
    }

    const handleInfoClick = async (record) => {
        const product = products?.find((item) => item?.code == record?.item_id);
        showLoading(layoutDispatch)
        try {

            const res = await Auth.fetch(`/product/product-details?id=${product?.netsuite_id}`)
            if (res?.ack) {
                if (res?.product_details.length > 0) {
                    const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
                    setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details, selectedRecord: product });
                    setModalVisibleProduct(true);
                    hideLoading(layoutDispatch)

                } else {
                    showMessage('error', 'No Details');
                    hideLoading(layoutDispatch)
                }
            } else {
                setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
                showMessage('error', res?.message)
                hideLoading(layoutDispatch)

            }

        } catch (error) {
            showMessage('error', 'something went wrong');
            hideLoading(layoutDispatch)
        }
    };

    const deleteTransaction = async (record) => {
        const dataToSend = {
            id: record?.id,
        }
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch('/route/route-packing-batch', {
                method: "DELETE",
                body: JSON.stringify(dataToSend)
            })
            if (res?.ack) {
                setPalletData(prevItems =>
                    prevItems.map(item => {
                        if (item.item_pallet_id == record?.item_pallet_id) {
                            const newRem = item?.remaining_quantity + Number(record?.quantity)
                            const newDispatchedQTY = Number(item.packed_quantity) - Number(record?.quantity)
                            return { ...item, packed_quantity: newDispatchedQTY, remaining_quantity: newRem };
                        }
                        return item;
                    })
                );
                setModalVisible(false)
                setCurrentProduct(null)
                getRoutePackingDetails(selectedRouteDetails?.palet_id)

            }
            else showMessage('error', res?.message)
        } catch (err) {
            showMessage('error', 'something went wrong')
        } finally {
            hideLoading(layoutDispatch)
        }
    }

    const itemTxnsCol = [
        {
            title: 'Batch Code',
            render(record) {
                const btachCodeItem = itemPickingTransactions?.find((txn) => txn?.id == record?.wms_product_location_txn_id);
                return (
                    <>{btachCodeItem?.batch_code || ''}</>
                );
            }
        },
        {
            title: 'Supplier Batch Code',
            render(record) {
                const btachCodeItem = itemPickingTransactions?.find((txn) => txn?.id == record?.wms_product_location_txn_id);
                return (
                    <>{btachCodeItem?.supplier_batch_code || ''}</>
                );
            }
        },
        // {
        //       title: 'Expiry ',
        //       render(record) {
        //         const btachCodeItem = itemPickingTransactions?.find((txn) => txn?.id == record?.wms_product_location_txn_id);
        //         return (
        //           <>{btachCodeItem?.expiry_date ? dayjs(btachCodeItem?.expiry_date).format('DD-MM-YYYY') : ''}</>
        //         );
        //       }
        //     },
        {
            title: "Expiry",
            render: (record) => {
                const btachCodeItem = itemPickingTransactions?.find((txn) => txn?.id == record?.wms_product_location_txn_id);

                const expiry = btachCodeItem?.expiry_date;
                if (!expiry) return "";

                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");

                let color = "green";
                if (diffDays < 0) {
                    color = "red";
                } else if (diffDays <= 7) {
                    color = "orange";
                }

                return <Tag style={{ fontSize: '15px' }} color={color}>{btachCodeItem?.expiry_date}</Tag>;
            }
        },
        {
            title: 'Quantity',
            render(record) {
                return (
                    <>{record?.quantity?.toLocaleString()}</>
                );
            }
        },

        {
            title: "User",
            render(record) {
                if (!record) return "";

                const user = record?.user_name || "";
                const helper = record?.helper_name || "";

                if (helper) {
                    return (
                        <>
                            {helper}{" "}
                            {user && (
                                <Tooltip title={`${user}`}>
                                    <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                                </Tooltip>
                            )}
                        </>
                    );
                }

                return <>{user}</>;
            }
        },

        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date) => dayjs(date).format("DD-MM-YYYY HH:mm:ss"),
        },

    ];
    if (!palletData[0]?.packed_by > 0) {
        itemTxnsCol.push(
            {
                title: 'Action',
                align: "right",
                dataIndex: '',
                render(record) {
                    return (
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <DeleteFilled style={
                                {
                                    fontSize: "25px",
                                    cursor: "pointer",
                                    color: "#cd1437",
                                }} onClick={() => {
                                    Modal.confirm({
                                        title: 'Delete Transaction',
                                        centered: true,
                                        content: `Are you sure you want to delete this transaction?`,
                                        onOk: () => deleteTransaction(record),
                                        okText: 'Delete',
                                        cancelText: 'Cancel',
                                        width: 600,
                                        okButtonProps: { size: "large" },
                                        cancelButtonProps: { size: "large" },
                                    });
                                }}
                            />
                        </div>
                    );
                },
            }
        )
    }

    const handleModalCancel = () => {
        setPackRouteStock({ product: "", product_id: '', quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, batch_code: null, batch_expiry: null, batch_quantity: null, batch_id: null })
        setModalVisible(false);
        setItemPickingTransactions([])
        setSelectedItem('');
        setCurrentProduct(null);
    };
    const productSelectValueChange = (val, isScanned) => {
        console.log('productSelectValueChange', val, isScanned);

        if (isScanned) {
            const selectedProduct = products?.find((pro) => pro?.code == val || pro?.barcode == val);
            const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
            if (selectedProduct && matchedProduct) {
                setCurrentProduct(selectedProduct)
                setPackRouteStock(prev => ({ ...prev, product_id: selectedProduct?.netsuite_id, quantity: '', remaining_quantity_check: false, fullPallet: false }));
            } else {
                setCurrentProduct(null)
                setPackRouteStock(prev => ({ ...prev, product_id: null, quantity: '', remaining_quantity_check: false, fullPallet: false }));
                showMessage('error', 'Invalid product selected')
            }

        } else {
            const selectedProduct = products?.find((pro) => pro?.netsuite_id == val);
            const matchedProduct = selectedItem?.item_internal_id == selectedProduct?.netsuite_id ? true : false;
            if (selectedProduct && matchedProduct) {
                setCurrentProduct(selectedProduct)
                setPackRouteStock(prev => ({ ...prev, product_id: val, quantity: '', remaining_quantity_check: false, fullPallet: false }));
            } else {
                setCurrentProduct(null)
                setPackRouteStock(prev => ({ ...prev, product_id: null, quantity: '', remaining_quantity_check: false, fullPallet: false }));
                showMessage('error', 'Invalid product selected')
            }
        }
    };

    const handleModalOk = async () => {
        if (!packRouteStock?.product_id || !packRouteStock?.batch_id || !packRouteStock?.quantity) {
            showMessage('error', 'Fill all required fields')
            return;
        }
        if (Number(packRouteStock?.quantity) < 1) return showMessage('error', 'Quantity must be greater than zero');
        const dataToSend = {
            product_netsuite_id: packRouteStock?.product_id,
            packed_quantity: packRouteStock?.quantity,
            id: packRouteStock?.id,
            route_status_id: selectedRoute?.id,
            purchase_order_details_batch_id: packRouteStock?.purchase_order_details_batch_id,
            pallet_number: selectedItem?.pallet_id,
            pallet_builder_id: selectedItem?.pallet_builder_id,
            item_pallet_id: selectedItem?.item_pallet_id,
            internal_id: selectedItem?.internal_id,
            sale_order_no: selectedItem?.sale_order_no,
            customer_code: selectedItem?.customer_name,
            customer_name: selectedItem?.customer_project_id,
            inv_internal_id: selectedItem?.inv_internal_id,
            invoice_no: selectedItem?.invoice_no,
            delivery_date: dayjs(deliveryDate).format('YYYY-MM-DD'),
            route_name: selectedRoute?.title,
            route_code: selectedRoute?.code,
            batch_code: packRouteStock?.batch_code,
            supplier_batch_code: packRouteStock?.supplier_batch_code,
            expiry_date: packRouteStock?.batch_expiry ? dayjs(packRouteStock?.batch_expiry).format('YYYY-MM-DD') : null


        };
        showLoading(layoutDispatch);
        try {
            const res = await Auth.fetch('/route/route-packing-batch', {
                method: 'PUT',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                showMessage('success', res?.message)

                setPalletData(prevItems =>
                    prevItems.map(item => {
                        if (item.item_pallet_id === selectedItem.item_pallet_id) {
                            const newRem = selectedItem?.remaining_quantity - Number(packRouteStock?.quantity)
                            const newDispatchedQTY = Number(item.packed_quantity) + Number(packRouteStock?.quantity)
                            return { ...item, packed_quantity: newDispatchedQTY, remaining_quantity: newRem };
                        }
                        return item;
                    })
                );
                setPackRouteStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, batch_code: null, batch_expiry: null, batch_quantity: null, batch_id: null })
                setModalVisible(false);
                setItemPickingTransactions([]);
                setCurrentProduct(null);
                getRoutePackingDetails(selectedRouteDetails?.palet_id)
            } else {
                showMessage('error', res?.message)
            }
        } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong');
        }
        finally {
            hideLoading(layoutDispatch)
        }

    };

    console.log('info', selectedRouteDetails);


    const lockPalletPacking = async (type) => {
        if (type !== 1) {
            const hasMismatch = palletData.some(item => {
                const picked = Number(item?.quantity ?? 0);
                const packed = Number(item?.packed_quantity ?? 0);
                return picked !== packed;
            });

            if (hasMismatch) {
                showMessage('error', 'Cannot lock pallet. All items must be fully packed.');
                return;
            }
        }
        showLoading(layoutDispatch);
        const url = type === 1 ? '/route/unlock-packing-pallet' : '/route/lock-packing-pallet';

        const dataToSend = {
            pallet_builder_id: palletData[0]?.pallet_builder_id,
        }
        try {
            const res = await Auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                if (type === 1) {
                    setRouteStatusData(prevItems =>
                        prevItems.map(item => {
                            if (item.pallet_id === selectedRouteDetails?.palet_id) {
                                return { ...item, pallet_packed_by: 0 };
                            }
                            return item;
                        })
                    );
                } else {
                    setRouteStatusData(prevItems =>
                        prevItems.map(item => {
                            if (item.pallet_id === selectedRouteDetails?.palet_id) {
                                return { ...item, pallet_packed_by: res?.pallet_packed_by || 1 };
                            }
                            return item;
                        })
                    );
                }
                showMessage('success', res?.message);
                drawerClose()
            } else {
                showMessage('error', res?.message);
            }
        } catch (err) {
            showMessage('error', 'Something went wrong');
        } finally {
            hideLoading(layoutDispatch)
        }
    }
    const infoItem = [
        { label: 'Ordered Quantity', value: selectedItem?.quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: '#1677ff' },
        { label: 'Remaining Picked Quantity', value: selectedItem?.remaining_picked_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} /> },
        { label: 'Remaining Packed Quantity', value: selectedItem?.remaining_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: selectedItem?.remaining_quantity > 0 ? 'red' : '#1677ff' },
    ]

    const quantityInfoItems = [
        { label: 'Total Picked Quantity', value: quantityRecord?.picked_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#005580" }} />, color: '#005580' },
        { label: 'Remaining Picked Quantity', value: quantityRecord?.remaining_picked_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#a32a00" }} />, color: '#a32a00' },
    ]

    const notesItem = {
        label: 'Lock Notes',
        value: palletData[0]?.packing_notes || '',
        readOnly: true,
        type: 'notes',
        icon: <SnippetsOutlined style={{ color: "#1677ff" }} />
    };

    return (
        <>
            <Drawer
                open={drawerOpen}
                onClose={drawerClose}
                height="100vh"
                title={
                    <Row gutter={[16, 16]} style={{ marginTop: 8, marginRight: 4 }}>
                        {infoItemsTitle.map(({ label, value }) => (
                            <Col key={label} xs={24} sm={12} md={6}>
                                <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 6, background: '#f5f5f5' }}>
                                    <Text type="secondary" style={{ display: 'block', marginBottom: 0, fontWeight: 'bold', fontSize: 15 }} >
                                        {label}
                                    </Text>
                                    <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                        {value}
                                    </Tag>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                }
                placement={"bottom"}
                bodyStyle={{ background: '#f5f5f5', padding: '10px', }}

            >
                <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                    {infoItems.map(({ label, value }) => (
                        <Col key={label} xs={24} sm={12} md={6}>
                            <Card size="small" style={{ textAlign: 'center' }} bodyStyle={{ padding: 8 }}>
                                <Text type="secondary" style={{ display: 'block', marginBottom: 4, fontWeight: 'bold' }}>
                                    {label}
                                </Text>
                                <Tag color="blue" style={{ fontSize: 15, fontWeight: 'bold' }}>
                                    {value}
                                </Tag>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <Divider style={{ margin: '10px 0px' }} />
                <Flex justify='space-between' align='center'>
                    <h3 style={{ margin: 0 }}>Pallet Packing</h3>
                    <Flex justify='end' align='center' style={{ gap: 8 }}>
                        <Button type="primary" icon={<CloudDownloadOutlined style={{ fontSize: 18 }} />} onClick={handleDownloadPdf}>
                            Download Item List
                        </Button>
                        <Button type="primary" icon={<PrinterFilled style={{ fontSize: 18 }} />} onClick={handleDownloadPalletLabel}>
                            Print Label
                        </Button>
                        {
                            palletData[0]?.packed_by > 0 ? (
                                <Button type='primary' icon={<UnlockFilled />} onClick={() => {
                                    Modal.confirm({
                                        title: 'Unlock Pallet Packing',
                                        centered: true,
                                        content: `Are you sure you to unlock packing for this pallet?`,
                                        onOk: () => lockPalletPacking(1),
                                        okText: 'Unlock',
                                        cancelText: 'Cancel',
                                        width: 600,
                                        okButtonProps: { size: "large" },
                                        cancelButtonProps: { size: "large" },
                                    });
                                }} >Unlock Packing</Button>
                            ) : (
                                <>
                                    {/* <Button danger icon={<LockFilled />}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'Lock Pallet Packing',
                                            centered: true,
                                            content: <>

                                                {` Are you sure you to lock packing for this pallet?`}
                                            </>,
                                            onOk: () => lockPalletPacking(2),
                                            okText: 'Lock',
                                            cancelText: 'Cancel',
                                            width: 600,
                                            okButtonProps: { size: "large" },
                                            cancelButtonProps: { size: "large" },
                                        });
                                    }}
                                >Lock Packing</Button> */}
                                    <LockPalletPackingButton
                                        selectedRouteDetails={selectedRouteDetails}
                                        palletData={palletData}
                                        setRouteStatusData={setRouteStatusData}
                                        drawerClose={drawerClose}
                                        routeStatusData={routeStatusData}
                                    />
                                </>

                            )
                        }
                    </Flex>
                </Flex>
                <TableSheet>
                    <Table
                        dataSource={palletData}
                        pagination={false}
                        columns={dataCol}
                        bordered
                        style={{ marginTop: "10px" }}
                        scroll={{ x: 'max-content' }}
                        // rowClassName={(record) => (record?.picked_quantity < 1 ? "highlight-row" : "")}
                        rowClassName={(record, index) => {
                            let className = "";
                            if (record?.quantity < 1) {
                                className += " highlight-row";
                            }
                            if (index % 2 === 0) {
                                className += " table-row-striped";
                            }
                            return className.trim();
                        }}
                    />
                </TableSheet>

                {
                    palletData?.length > 0 && palletData[0]?.packed_by > 0 && (
                        <>
                            <Row style={{ marginTop: 10 }}>
                                <Col span={12}>
                                    <InputBox inputItem={notesItem} inputType={'notes'} />
                                </Col>
                            </Row>
                            <Image.PreviewGroup>
                                {palletData?.length > 0 &&
                                    JSON.parse(palletData[0]?.packing_files)?.map((item, index) => {
                                        const imageUrl = `${wms_uploads_cdn}/${env}/route-packing/${selectedRouteDetails?.id}/${item.replace(/\+/g, '%2B')}`;
                                        return (
                                            <div key={index} style={{ marginRight: 10, display: 'inline-block' }}>
                                                <Image
                                                    width={225}
                                                    height={125}
                                                    style={{ padding: 5, border: '1px solid lightgrey' }}
                                                    src={imageUrl}
                                                />
                                            </div>
                                        );
                                    })}
                            </Image.PreviewGroup>
                        </>
                    )
                }


                <Modal width={'70VW'} title={`Item Packing: ${selectedItem?.item_id} - ${selectedItem?.item_name}`} open={modalVisible}
                    okButtonProps={{ style: { display: 'none' } }}
                    cancelButtonProps={{ style: { display: selectedItem?.remaining_quantity > 0 && 'none' } }}

                    onCancel={handleModalCancel} >
                    <Divider style={{ margin: '2px 2px' }} />

                    <DetailsGrid infoItems={infoItem} size={'small'} />
                    <>
                        {
                            selectedItem?.remaining_quantity > 0 && !palletData[0]?.packed_by > 0 && (
                                <>
                                    <Row style={{ marginBottom: "10px" }}>
                                        <Col xs={{ span: 24, order: 2 }} md={{ span: 14, order: 1 }}>
                                            <Row style={{ marginBottom: "10px" }}>
                                                <Col style={{ flex: 1 }}>
                                                    <Text>Product</Text>
                                                    <ProductScanSelect
                                                        onValueChange={productSelectValueChange}
                                                        value={packRouteStock?.product_id}
                                                        options={products} placeholder="Product"
                                                        size="large"
                                                        length={'100%'}
                                                        productRef={productRef}
                                                    />
                                                </Col>
                                            </Row>
                                            {
                                                packRouteStock?.product_id && (
                                                    <Row>
                                                        <Col style={{ flex: 1 }}>
                                                            <Text>Item Batches</Text>
                                                            {/* <br /> */}
                                                            <Select
                                                                autoFocus
                                                                placeholder="Item Batches"
                                                                size="large"
                                                                showSearch
                                                                style={{ width: '100%' }}
                                                                filterOption={(input, option) =>
                                                                    option?.label?.props?.children
                                                                        ?.map?.((el) => (typeof el === 'string' ? el : ''))
                                                                        .join(' ')
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                                value={packRouteStock?.batch_id}
                                                                onChange={(value) => {
                                                                    const selectedBatch = itemPickingTransactions?.find((item) => item?.id == value)
                                                                    setPackRouteStock({
                                                                        ...packRouteStock,
                                                                        batch_id: value,
                                                                        batch_quantity: selectedBatch?.final_quantity || 0,
                                                                        id: selectedBatch?.id || null,
                                                                        purchase_order_details_batch_id: selectedBatch?.purchase_order_details_batch_id || 0,
                                                                        batch_code: selectedBatch?.batch_code || 0,
                                                                        supplier_batch_code: selectedBatch?.supplier_batch_code || 0,
                                                                        batch_expiry: selectedBatch?.expiry_date || 0,
                                                                    });
                                                                }}
                                                                optionLabelProp="label"
                                                            >
                                                                {itemPickingTransactions.map((item) => {
                                                                    const label = (
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                            <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.quantity}</Tag>
                                                                            <Tag color={item?.final_quantity > 0 ? "green" : 'red'} style={{ margin: 0 }}>Remaining Qty: {item?.final_quantity}</Tag>
                                                                            <Tag color='blue' style={{ margin: 0 }}>
                                                                                Batch Code: {item?.supplier_batch_code ? item?.supplier_batch_code : 'N/A'}
                                                                            </Tag>
                                                                            {/* <Tag color={'blue'} style={{ fontSize: '13px', fontWeight: 500 }}>
                                                                        Exp: {item?.expiry_date ? dayjs(item?.expiry_date).format('DD-MM-YYYY') : 'N/A'}
                                                                    </Tag> */}
                                                                        </div>
                                                                    );

                                                                    return (
                                                                        <Option key={item.id} value={item.id} label={label} disabled={item?.final_quantity === 0} style={{ padding: 0 }}>
                                                                            <div
                                                                                style={{
                                                                                    padding: '8px 12px',
                                                                                    margin: '4px 0',
                                                                                    border: '1px solid #f0f0f0',
                                                                                    borderRadius: '8px',
                                                                                    backgroundColor: '#fafafa',
                                                                                }}
                                                                            >
                                                                                <Flex justify='space-between' wrap style={{ marginBottom: 4 }}>

                                                                                    <Tag color="blue" style={{ margin: 0 }}>Qty: {item?.quantity}</Tag>
                                                                                    <Tag color={item?.final_quantity > 0 ? "green" : 'red'} style={{ margin: 0 }}>Remaining Qty: {item?.final_quantity}</Tag>
                                                                                    <Tag color='blue' style={{ fontSize: '13px', fontWeight: 500 }}>
                                                                                        Batch Code: {item?.supplier_batch_code ? item?.supplier_batch_code : 'N/A'}
                                                                                    </Tag>
                                                                                    <Tag color={'blue'} style={{ fontSize: '13px', fontWeight: 500 }}>
                                                                                        Exp: {item?.expiry_date ? dayjs(item?.expiry_date).format('DD-MM-YYYY') : 'N/A'}
                                                                                    </Tag>
                                                                                </Flex>

                                                                            </div>
                                                                        </Option>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </Col>
                                                    </Row>
                                                )
                                            }

                                            {
                                                packRouteStock?.batch_id && (
                                                    <Row >
                                                        <Col style={{ flex: 1 }}>
                                                            <Text>Quantity</Text>
                                                            <Flex align="center" gap="small" wrap>
                                                                <Input size="large" autoFocus type='number' value={packRouteStock?.quantity}
                                                                    onChange={(e) => {
                                                                        const raw = e.target.value;
                                                                        const newQty = /^\d*$/.test(raw) ? raw.replace(/^0+(?=\d)/, "") : '1';
                                                                        if (!packRouteStock?.product_id) return showMessage('error', 'Select a product first');
                                                                        if (!packRouteStock?.batch_id) return showMessage('error', 'Select a Batch first');
                                                                        if (newQty > packRouteStock?.batch_quantity) return showMessage('error', 'Quantity can not be greater than batch quantity');
                                                                        if (newQty > Number(selectedItem?.remaining_quantity)) return showMessage('error', 'Quantity cannot be greater than remaining quantity!');
                                                                        // if (newQty < 1) return showMessage('error', 'Quantity cannot be less than one!');

                                                                        setPackRouteStock({ ...packRouteStock, quantity: newQty })

                                                                    }
                                                                    }
                                                                    placeholder="Enter Quantity" />
                                                                {
                                                                    packRouteStock?.remainQtyShow && (
                                                                        <Checkbox
                                                                            checked={packRouteStock?.remaining_quantity_check}
                                                                            style={{ fontSize: '16px', width: '100%' }}
                                                                            onChange={(e) => {
                                                                                const isChecked = e.target.checked;
                                                                                const qtyRemaing = selectedItem?.remaining_quantity;

                                                                                if (isChecked) {
                                                                                    if (!packRouteStock?.product_id) {
                                                                                        showMessage('error', 'Please select a product first');
                                                                                        return;
                                                                                    }

                                                                                    if (!packRouteStock?.batch_id) {
                                                                                        showMessage('error', 'Please select a batch first ');
                                                                                        return
                                                                                    }
                                                                                    if (qtyRemaing > packRouteStock?.batch_quantity) {
                                                                                        showMessage('error', 'remaining quantity exceeding batch quantity')
                                                                                        return
                                                                                    }

                                                                                    setPackRouteStock({ ...packRouteStock, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                                                                                }
                                                                                else {
                                                                                    setPackRouteStock({ ...packRouteStock, quantity: '', remaining_quantity_check: false });
                                                                                }
                                                                            }}
                                                                        >
                                                                            Remaining Quantity
                                                                        </Checkbox>
                                                                    )
                                                                }
                                                                {
                                                                    packRouteStock?.fullPalletShow && (
                                                                        <Checkbox
                                                                            checked={packRouteStock?.fullPallet}
                                                                            size="large"
                                                                            style={{ marginTop: "10px" }}
                                                                            onChange={(e) => {
                                                                                const isChecked = e.target.checked;
                                                                                if (isChecked) {

                                                                                    if (!packRouteStock?.product_id) return showMessage("error", "Select product first");
                                                                                    if (!packRouteStock?.batch_id) return showMessage("error", "Select batch first");
                                                                                    const selectedProduct = products?.find((pro) => pro?.netsuite_id == packRouteStock?.product_id);
                                                                                    const qtyRemaing = selectedItem?.remaining_quantity;
                                                                                    const fullPalletQty = selectedProduct?.cases_in_pallets;

                                                                                    if (fullPalletQty > Number(packRouteStock?.batch_quantity)) return showMessage("error", "Exceeds batch quantity");
                                                                                    if (fullPalletQty > qtyRemaing) {
                                                                                        showMessage('error', 'Remaining quantity is less than pallet quantity')
                                                                                        return;
                                                                                    } else {
                                                                                        setPackRouteStock({ ...packRouteStock, quantity: fullPalletQty, fullPallet: e.target.checked })
                                                                                    }
                                                                                } else {
                                                                                    setPackRouteStock({ ...packRouteStock, quantity: '', fullPallet: false });
                                                                                }

                                                                            }
                                                                            }
                                                                        >
                                                                            Full Pallet
                                                                        </Checkbox>
                                                                    )
                                                                }
                                                            </Flex>

                                                        </Col>
                                                    </Row>
                                                )
                                            }
                                        </Col>
                                        <Col
                                            xs={{ span: 24, order: 1 }}
                                            md={{ span: 6, offset: 2, order: 2 }}
                                            style={{ textAlign: "center", marginBottom: 16 }}
                                        >
                                            <Image
                                                src={imageUrl}
                                                preview={false}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: 300,
                                                    height: "auto",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Col>
                                    </Row>

                                    <Flex justify='end' gap={5}>
                                        <Button onClick={handleModalCancel}>Cancel</Button>
                                        <Button type='primary' onClick={handleModalOk}>Save</Button>
                                    </Flex>
                                    <Divider />
                                </>
                            )
                        }

                        {
                            itemPackingTransactions.length > 0 && (
                                <div style={{ marginTop: 10 }}>
                                    <Table columns={itemTxnsCol}
                                        dataSource={itemPackingTransactions}
                                        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                                        pagination={false} scroll={{ x: 'max-content' }} />
                                </div>
                            )
                        }

                    </>

                </Modal>
            </Drawer>
            <ProductInfoModal
                visible={modalVisibleProduct}
                onCancel={handleModalCancelProduct}
                selectedItemDetails={selectedProductDetails}
                selectedItems={selectedProductDetails?.productDetails}
                selectedRecord={selectedProductDetails?.selectedRecord}
            />
            <Modal
                width={450}
                title={
                    <Text style={{ fontSize: '18px', fontWeight: 600 }}>Picking Details</Text>
                }
                open={quantityModalVisible}
                onCancel={() => setQuantityModalVisible(false)}
                footer={null}
                centered
                bodyStyle={{ padding: '0px 24px 24px 24px' }}
            >
                <Divider style={{ margin: '12px 0 20px 0' }} />

                <div style={{ marginBottom: 24, padding: '12px', background: '#f9f9f9', borderRadius: '8px', borderLeft: '4px solid #52c41a' }}>
                    <Text type="secondary" style={{ fontSize: '12px', display: 'block', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Item Information</Text>
                    <Text style={{ fontSize: '15px', fontWeight: 500, color: '#262626' }}>
                        {quantityRecord?.item_id} - {quantityRecord?.item_name}
                    </Text>
                </div>

                <Flex vertical gap={16}>
                    <div style={{
                        background: 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)',
                        padding: '20px',
                        borderRadius: '16px',
                        border: '1px solid #91d5ff',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        boxShadow: '0 4px 12px rgba(0, 109, 117, 0.1)'
                    }}>
                        <Flex align="center" gap={12}>
                            <NumberOutlined style={{ fontSize: '24px', color: '#0050b3' }} />
                            <Text style={{ fontSize: '20px', fontWeight: 600, color: '#0050b3' }}>Total Picked</Text>
                        </Flex>
                        <Text style={{ fontSize: '28px', fontWeight: 800, color: '#0050b3' }}>
                            {quantityRecord?.picked_quantity?.toLocaleString() || 0}
                        </Text>
                    </div>

                    <div style={{
                        background: 'linear-gradient(135deg, #fff1f0 0%, #ffccc7 100%)',
                        padding: '20px',
                        borderRadius: '16px',
                        border: '1px solid #ffa39e',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        boxShadow: '0 4px 12px rgba(168, 17, 0, 0.1)'
                    }}>
                        <Flex align="center" gap={12}>
                            <NumberOutlined style={{ fontSize: '24px', color: '#a8071a' }} />
                            <Text style={{ fontSize: '20px', fontWeight: 600, color: '#a8071a' }}>Remaining Picked</Text>
                        </Flex>
                        <Text style={{ fontSize: '28px', fontWeight: 800, color: '#a8071a' }}>
                            {quantityRecord?.remaining_picked_quantity?.toLocaleString() || 0}
                        </Text>
                    </div>
                </Flex>

                <div style={{ marginTop: 32 }}>
                    <Button
                        type="primary"
                        block
                        size="large"
                        onClick={() => setQuantityModalVisible(false)}
                        style={{
                            height: '48px',
                            borderRadius: '12px',
                            fontSize: '16px',
                            fontWeight: 600,
                            boxShadow: '0 4px 10px rgba(22, 119, 255, 0.3)'
                        }}
                    >
                        Close
                    </Button>
                </div>
            </Modal>
        </>
    )
}

export default PalletDrawer